export enum CLAUSES_LIST_COLUMNS {
  CLAUSE_NAME = 'Clause Name',
  STATUS = 'Status',
  FAILURE_REASON = 'Failure Reason',
}
